export default __webpack_public_path__ + "static/media/btnGuardians.e2383ee8.png";